import { Controller } from "@hotwired/stimulus"

// Controller for the Admin Rails Console
export default class extends Controller {
  static targets = ["input", "form"]
  
  connect() {
    // Focus the input on connect
    if (this.hasInputTarget) {
      this.inputTarget.focus()
    }
  }
  
  // Handle keyboard shortcut (Ctrl+Enter or Cmd+Enter)
  handleKeydown(event) {
    if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') {
      event.preventDefault()
      this.submit()
    }
  }
  
  // Submit the form
  submit() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
  
  // Run a quick command
  runCommand(event) {
    const code = event.currentTarget.dataset.code
    if (this.hasInputTarget && code) {
      this.inputTarget.value = code
      this.submit()
    }
  }
  
  // Clear history
  clearHistory() {
    if (confirm('Clear command history?')) {
      // Submit a form to clear history
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = this.element.dataset.consoleClearUrl
      
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      if (csrfToken) {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'authenticity_token'
        input.value = csrfToken
        form.appendChild(input)
      }
      
      const clearInput = document.createElement('input')
      clearInput.type = 'hidden'
      clearInput.name = 'clear_history'
      clearInput.value = '1'
      form.appendChild(clearInput)
      
      document.body.appendChild(form)
      form.submit()
    }
  }
}

